var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4723 14.9999C7.28147 14.9999 4.45097 13.0046 3.10472 9.99992C4.45097 6.99522 7.28147 4.99992 10.4723 4.99992C13.6631 4.99992 16.4936 6.99523 17.8398 9.99992C16.4936 13.0046 13.6631 14.9999 10.4723 14.9999ZM19.5845 10.1442C19.6202 10.0515 19.6202 9.94837 19.5845 9.85568C18.1092 6.02975 14.5874 3.33325 10.4723 3.33325C6.35713 3.33325 2.83537 6.02975 1.36006 9.85568C1.32432 9.94837 1.32432 10.0515 1.36006 10.1442C2.83537 13.9701 6.35713 16.6666 10.4723 16.6666C14.5874 16.6666 18.1092 13.9701 19.5845 10.1442ZM8.62614 9.99992C8.62614 8.96503 9.46508 8.12609 10.5 8.12609C11.5349 8.12609 12.3738 8.96503 12.3738 9.99992C12.3738 11.0348 11.5349 11.8738 10.5 11.8738C9.46508 11.8738 8.62614 11.0348 8.62614 9.99992ZM10.5 6.45942C8.54461 6.45942 6.95947 8.04456 6.95947 9.99992C6.95947 11.9553 8.54461 13.5404 10.5 13.5404C12.4553 13.5404 14.0405 11.9553 14.0405 9.99992C14.0405 8.04456 12.4553 6.45942 10.5 6.45942Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.db0cc2987316be18766ea7fa2768d6b1.svg";
export { ForwardRef as ReactComponent };